import React from "react";
import { useNavigate } from "react-router-dom";

export default function LabCard({ lab }) {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    if (lab?.id) {
      navigate(`/LabDetails/${lab.id}`, {
        state: { lab },
      });
    }
  };

  if (!lab) return null;

  return (
    <div
      onClick={handleViewDetails}
      className="w-[240px] h-[320px] rounded-xl overflow-hidden cursor-pointer 
      bg-white flex flex-col shadow-md hover:shadow-2xl 
      transition duration-500 flex-shrink-0 group"
    >
      {/* IMAGE */}
      <div className="w-full h-[150px] flex items-center justify-center bg-gray-50 relative overflow-hidden">
        <img
          src={
            lab?.image && lab.image !== "https://placehold.co/400x250?text=No+Image"
              ? lab.image
              : "https://placehold.co/400x250?text=No+Image"
          }
          alt={lab?.name || "Lab"}
          className="w-full h-full object-cover transform group-hover:scale-105 transition duration-500"
          onError={(e) => {
            e.target.onerror = null; // Prevent infinite loop
            e.target.src = "https://placehold.co/400x250?text=No+Image";
          }}
        />

        {/* optional overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-60 transition"></div>
      </div>

      {/* DETAILS */}
      <div className="flex-1 p-3 flex flex-col justify-between">
        <div>
          <h6 className="font-semibold text-sm mb-1 truncate">
            {lab?.name || "Unnamed Lab"}
          </h6>

          <p className="text-xs text-gray-500 h-[32px] overflow-hidden">
            {lab?.address || "No address available"}
          </p>
        </div>

        <p className="text-xs text-gray-400 mt-2">
          {lab?.distanceKm !== undefined && lab?.distanceKm !== null
            ? `${typeof lab.distanceKm === 'number' ? lab.distanceKm.toFixed(2) : lab.distanceKm} km away`
            : ""}
        </p>
      </div>
    </div>
  );
}